import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import './auth.css';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setInfo('');
    setLoading(true);

    const { data, error: signInError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    setLoading(false);

    if (signInError) {
      setError(signInError.message || 'Unable to sign in. Please check your credentials.');
      return;
    }

    if (data?.session) {
      navigate('/home');
    } else {
      setError('Login did not complete. Please try again.');
    }
  };

  const handleForgotPassword = async () => {
    setError('');
    setInfo('');
    if (!email) {
      setError('Please enter your email first so we can send a reset link.');
      return;
    }
    setLoading(true);
    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin + '/reset-password',
    });
    setLoading(false);

    if (resetError) {
      setError(resetError.message || 'Unable to send reset email. Please try again.');
    } else {
      setInfo('If an account exists for that email, a reset link has been sent.');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title">Sign in</h1>
        <p className="auth-subtitle">Access your ReplyFirst dashboard</p>
        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="auth-label">
            Email
            <input
              type="email"
              className="auth-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </label>
          <label className="auth-label">
            Password
            <input
              type="password"
              className="auth-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </label>
          {error && <div className="auth-message auth-message-error">{error}</div>}
          {info && <div className="auth-message auth-message-info">{info}</div>}
          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <button
          type="button"
          className="auth-link-button"
          onClick={handleForgotPassword}
          disabled={loading}
        >
          Forgot password?
        </button>
        <p style={{ textAlign: 'center', fontSize: '13px', color: '#5A6B84', marginTop: '16px' }}>
          Don't have an account?{' '}
          <Link to="/signup" style={{ color: '#1A56DB', fontWeight: 600, textDecoration: 'none' }}>
            Start free trial
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Login;